module.exports = __webpack_public_path__ + "img/A高通锐化200.aa2e8dcb.png";